"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImgUploadBigSize = exports.getDuccConfig = exports.getVideoPin = exports.getEncryptPin = exports.checkIsLogin = exports.isLogin = exports.isSeoUrlInfo = exports.queryMappingSeoUrlInfo = exports.defaultSubmitOrderGW = exports.getOpenIdByUserPin = exports.getPayUrl = exports.wxMiniPayDiagOrderNew = exports.getJsTicket = exports.request = exports.goLogin = exports.apppid = exports.getBaseUrl = exports.hostConfig = exports.hostAppidConfig = exports.myAppId = void 0;
var axios_1 = __importDefault(require("axios"));
var qs_1 = __importDefault(require("qs"));
var seoLocationWatcher_1 = require("../seo/seoLocationWatcher");
var wx_1 = require("../tools/wx");
var wxTool_1 = require("../tools/wxTool");
var getGlobalWindow_1 = require("../tools/getGlobalWindow");
var checkIsProd_1 = require("../tools/checkIsProd");
var sgm_1 = require("../tools/sgm");
exports.myAppId = "jd_nethp_patient_h5";
// 不同域名 登录配置APPID
exports.hostAppidConfig = {
    jd: {
        appid: "",
        host: "api.m.jd.com",
        hostYf: "beta-api.m.jd.com",
    },
    healthjd: {
        appid: "445",
        host: "color.healthjd.com",
        hostYf: "beta-api.healthjd.com",
    },
    yiyaojd: {
        appid: "270",
        host: "color.yiyaojd.com",
        hostYf: "beta-api.yiyaojd.com",
    },
    jkcsjd: {
        appid: "877",
        host: "color.jkcsjd.com",
        hostYf: "beta-api.m.jd.com",
    },
    jdh: {
        appid: "1880",
        host: "color.jdh.com",
        hostYf: "color.jdh.com",
    },
    contjd: {
        appid: "1962",
        host: "api.m.jd.com",
        hostYf: "beta-api.m.jd.com",
    },
};
var hostConfig = function () {
    var _a;
    var wd = (0, getGlobalWindow_1.getWindow)();
    if (wd === null || wd === void 0 ? void 0 : wd.getHostConfig) {
        return (_a = wd === null || wd === void 0 ? void 0 : wd.getHostConfig) === null || _a === void 0 ? void 0 : _a.call(wd);
    }
    var domain = wd.location.host;
    var healthjd = new RegExp(".*\\.(healthjd)\\.com.*$");
    var jd = new RegExp(".*\\.(jd)\\.com.*$");
    var yiyaojd = new RegExp(".*\\.(yiyaojd)\\.com.*$");
    var jkcsjd = new RegExp(".*\\.(jkcsjd)\\.com.*$");
    var jdh = new RegExp(".*\\.(jdh)\\.com.*$");
    var contjd = new RegExp(".*\\.(cont.jd)\\.com.*$");
    if (jdh.test(domain))
        return exports.hostAppidConfig["jdh"];
    if (contjd.test(domain))
        return exports.hostAppidConfig["contjd"];
    if (jd.test(domain))
        return exports.hostAppidConfig["jd"];
    if (healthjd.test(domain))
        return exports.hostAppidConfig["healthjd"];
    if (yiyaojd.test(domain))
        return exports.hostAppidConfig["yiyaojd"];
    if (jkcsjd.test(domain))
        return exports.hostAppidConfig["jkcsjd"];
    return {
        appid: "445",
        host: "color.healthjd.com",
        hostYf: "beta-api.healthjd.com",
    };
};
exports.hostConfig = hostConfig;
var getBaseUrl = function () {
    var _HostConfig = (0, exports.hostConfig)();
    var isProd = (0, checkIsProd_1.checkIsProd)();
    var baseUrl = isProd ? _HostConfig.host : _HostConfig.hostYf;
    return "//".concat(baseUrl) || "//color.healthjd.com";
};
exports.getBaseUrl = getBaseUrl;
var apppid = function () {
    // 需要appid来打通登陆态
    // plogin.jdh.com和punion.jdh.com已经都接入统一登陆了，appid申请的是1880
    var seoCheck = (0, seoLocationWatcher_1.checkIsSeoPage)();
    if (seoCheck.isJdh) {
        return 1880;
    }
    if (seoCheck.isContJd) {
        return 1962;
    }
    var _HostConfig = (0, exports.hostConfig)();
    return Number(_HostConfig === null || _HostConfig === void 0 ? void 0 : _HostConfig.appid) || 445;
};
exports.apppid = apppid;
function goLogin() {
    return __awaiter(this, void 0, void 0, function () {
        var wd, returnUrl, loginUrl, wx, e_1, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    wd = (0, getGlobalWindow_1.getWindow)();
                    returnUrl = wd.location.href;
                    if (!(0, wxTool_1.isMiniprogram)()) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    loginUrl = "/pages/login/index/index?returnPage=".concat(encodeURIComponent(returnUrl), "&pageType=h5");
                    return [4 /*yield*/, (0, wx_1.getwx)()];
                case 2:
                    wx = _a.sent();
                    if (sessionStorage.getItem("loginNavigator") === "true") {
                        wx.miniProgram.navigateTo({
                            url: loginUrl,
                        });
                    }
                    else {
                        wx.miniProgram.redirectTo({
                            url: loginUrl,
                        });
                    }
                    return [2 /*return*/];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4:
                    url = "//plogin.m.jd.com/user/login.action?appid=".concat((0, exports.apppid)(), "&returnurl=").concat(encodeURIComponent(returnUrl));
                    wd.location.replace(url);
                    return [2 /*return*/];
            }
        });
    });
}
exports.goLogin = goLogin;
var request = function (functionId, method, param_json) {
    var _a, _b, _c;
    if (method === void 0) { method = "GET"; }
    var wd = (0, getGlobalWindow_1.getWindow)();
    if (wd === null || wd === void 0 ? void 0 : wd.REAL_REQUEST_FUNC) {
        return (_a = wd === null || wd === void 0 ? void 0 : wd.REAL_REQUEST_FUNC) === null || _a === void 0 ? void 0 : _a.call(wd, functionId, method, param_json);
    }
    if (wd === null || wd === void 0 ? void 0 : wd[functionId]) {
        return (_b = wd === null || wd === void 0 ? void 0 : wd[functionId]) === null || _b === void 0 ? void 0 : _b.call(wd, functionId, method, param_json);
    }
    var url = "".concat((0, exports.getBaseUrl)(), "/api");
    if (!param_json || param_json.loginAuth === undefined) {
        param_json = __assign(__assign({}, param_json), { loginAuth: true });
    }
    var params = {
        functionId: functionId,
        body: JSON.stringify(__assign({}, param_json)),
        // appid: 'laputa',
        //loginType: 2
        appid: (wd === null || wd === void 0 ? void 0 : wd.getAppid)
            ? (_c = wd === null || wd === void 0 ? void 0 : wd.getAppid) === null || _c === void 0 ? void 0 : _c.call(wd, functionId, method, param_json)
            : exports.myAppId,
    };
    var options = {
        method: method,
        url: url,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        withCredentials: true,
        data: "",
        params: {},
    };
    if (method === "GET") {
        options.params = __assign(__assign({}, params), { _v: new Date().getTime() });
    }
    else if (method === "POST") {
        // @ts-ignore
        var contentType = options.headers["Content-Type"].toLowerCase();
        if (contentType === "application/json") {
            options.data = JSON.stringify(params);
        }
        else if (contentType === "application/x-www-form-urlencoded") {
            options.data = qs_1.default.stringify(params);
        }
    }
    var promise = new Promise(function (resolve, reject) {
        (0, axios_1.default)(options)
            .then(function (response) {
            var _a;
            (0, sgm_1.sgmReport)({
                type: "3",
                code: "response code is ".concat(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code) || "none"),
                msg: {
                    params: params,
                    response: response,
                },
            });
            // 0019是无效pin，暂时去登陆
            var loginCode = ["1023", "0019"];
            if (loginCode.some(function (item) { return item === response.data.code; }) &&
                param_json.loginAuth) {
                goLogin();
                return;
            }
            resolve(response.data);
        })
            .catch(function (err) {
            (0, sgm_1.sgmReport)({
                type: "1",
                code: "response code is error",
                msg: {
                    params: params,
                    err: err,
                },
            });
            reject(err);
        });
    });
    return promise;
};
exports.request = request;
// 微信分享
var getJsTicket = function (data) {
    return (0, exports.request)("wechat_getJsTicket", "POST", data);
};
exports.getJsTicket = getJsTicket;
// 小程序支付参数新
var wxMiniPayDiagOrderNew = function (data) {
    return (0, exports.request)("NHPPPayDiag_wxMiniPayDiagByJSF", "POST", data);
};
exports.wxMiniPayDiagOrderNew = wxMiniPayDiagOrderNew;
// 获取支付链接
var getPayUrl = function (data) {
    return (0, exports.request)("NHPFPayOrderExport_payDiagOrder", "POST", data);
};
exports.getPayUrl = getPayUrl;
// 通过用户pin获取小程序openid
var getOpenIdByUserPin = function (data) {
    return (0, exports.request)("BNHFWechatService_getOpenIdByUserPin", "POST", data);
};
exports.getOpenIdByUserPin = getOpenIdByUserPin;
// 新的提单接口
var defaultSubmitOrderGW = function (data) {
    return (0, exports.request)("NHPFCoreSubmitOrder_defaultSubmitOrderGW", "POST", data);
};
exports.defaultSubmitOrderGW = defaultSubmitOrderGW;
// 通过源地址获取对应的SEO地址
var queryMappingSeoUrlInfo = function (data) {
    return (0, exports.request)("jdh_seo_c_queryMappingSeoUrlInfo", "POST", data);
};
exports.queryMappingSeoUrlInfo = queryMappingSeoUrlInfo;
// 判断当前地址是否是SEO地址
var isSeoUrlInfo = function (data) {
    // request("jdh_seo_c_isSeoUrlInfo", "POST", data);
    return (0, exports.request)("jdh_seo_c_isSeoSite", "POST", data);
}; // jdh_seo_c_isSeoSite 性能更好
exports.isSeoUrlInfo = isSeoUrlInfo;
// 是否登录
var isLogin = function () { return (0, exports.request)("BNHFUser_isLogin", "POST"); };
exports.isLogin = isLogin;
var checkIsLogin = function () {
    return (0, exports.isLogin)().then(function (res) {
        var islg = (res && res.code == "1027") ||
            (res && res.code == "0000" && res.data == true) ||
            res == true;
        return islg;
    });
};
exports.checkIsLogin = checkIsLogin;
// 获取视频上传特殊加密参数
var getEncryptPin = function (data) {
    return (0, exports.request)("jdh_media_getEncryptPin", "POST", data);
};
exports.getEncryptPin = getEncryptPin;
var getVideoPin = function () { return __awaiter(void 0, void 0, void 0, function () {
    var wd, pro;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                wd = (0, getGlobalWindow_1.getWindow)();
                if (wd.encryptPin) {
                    return [2 /*return*/, wd.encryptPin];
                }
                if (!wd.encryptPinPromise) return [3 /*break*/, 2];
                return [4 /*yield*/, wd.encryptPinPromise];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                pro = (0, exports.getEncryptPin)({}).then(function (res) {
                    var encryptPin = "";
                    if (res && res.code == "0000" && res.data && res.data.encryptPin) {
                        encryptPin = res.data.encryptPin;
                    }
                    wd.encryptPin = encryptPin;
                    return encryptPin;
                });
                wd.encryptPinPromis = pro;
                return [4 /*yield*/, pro];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getVideoPin = getVideoPin;
// ducc接口
var getDuccConfig = function (data) {
    return (0, exports.request)("NHPFCore_GetDuccConfig", "POST", data);
};
exports.getDuccConfig = getDuccConfig;
// 图片上传大图时的判断信息，用于大图走京东云上传流程
var getImgUploadBigSize = function () { return __awaiter(void 0, void 0, void 0, function () {
    var wd, pro;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                wd = (0, getGlobalWindow_1.getWindow)();
                if (wd.imgUploadBigSizeInfo !== undefined) {
                    return [2 /*return*/, wd.imgUploadBigSizeInfo];
                }
                if (!wd.imgUploadBigSizeInfoPromise) return [3 /*break*/, 2];
                return [4 /*yield*/, wd.imgUploadBigSizeInfoPromise];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                pro = (0, exports.getDuccConfig)({
                    duccKey: "imgUploadBigSizeInfo",
                }).then(function (res) {
                    try {
                        var data = JSON.parse(res.data.data);
                        wd.imgUploadBigSizeInfo = data;
                        return data;
                    }
                    catch (e) {
                        return {};
                    }
                });
                wd.imgUploadBigSizeInfoPromise = pro;
                return [4 /*yield*/, pro];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getImgUploadBigSize = getImgUploadBigSize;
